export default __webpack_public_path__ + "static/media/1738.167ccb4d.png";